import { SignupForm } from "@/components/auth/signup-form"
import { AuthPageShell } from "@/components/auth/auth-page-shell"
import { AccessRequestFormAuth } from "@/components/auth/access-request-form-auth"
import { useAuth } from "@/hooks/use-auth"
import { useNavigate, useSearchParams } from "react-router-dom"
import { navigateWithThreadPreservation } from "@/utils/thread-navigation"
import { getAccessRequestConfig, registrationClosed } from "@/constants/signup"
import { useEffect } from "react"

export function SignupPage() {
  const { isAuthenticated } = useAuth()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const accessRequestConfig = getAccessRequestConfig()

  useEffect(() => {
    if (isAuthenticated) {
      navigateWithThreadPreservation(navigate, '/profile', searchParams)
    }
  }, [isAuthenticated, navigate, searchParams])

  useEffect(() => {
    if (registrationClosed() && accessRequestConfig.hideRegisterPage) {
      navigate('/', { replace: true })
    }
  }, [accessRequestConfig.hideRegisterPage, navigate])

  const handleSignupSuccess = () => {
    // Navigation will happen via useEffect when auth state changes or via form redirect
  }

  if (registrationClosed()) {
    return (
      <AuthPageShell title={accessRequestConfig.heading ?? 'Request access'}>
        <AccessRequestFormAuth />
      </AuthPageShell>
    )
  }

  return (
    <AuthPageShell title="Create an account">
      <SignupForm onSuccess={handleSignupSuccess} />
    </AuthPageShell>
  )
}
